import CoregsCreate from './CoregsCreate'
import CoregsList from './CoregsList'
import CoregsEdit from './CoregsEdit'

export default {
  create: CoregsCreate,
  list: CoregsList,
  edit: CoregsEdit,
}
